<div class="modal-container modal-xs justify-between md:justify-normal"
     >
    <div class="modal-close-container">
        @if (model.showCloseButton) {
        <bizz-icon class="ml-auto block h-5 w-5 text-button md:ml-0"
                   (click)="dialogRef.close()"
                   iconName="xmark" [hover]="true">
        </bizz-icon>
        }
    </div>
    <div class="modal-body">
        <div class="modal-header">
            <h1 class="mb-5 text-center font-title text-xl font-bold text-default">
                {{ model.title | translate }}</h1>
            @if (model.message && model.mode !== DialogModalModelMode.simple) {
                <p class="text-center text-sm font-normal">
                    {{ model.message | translate }}
                </p>
            }
        </div>
        <hr class="my-5"/>
        @if (model.message && model.mode == DialogModalModelMode.simple) {
            <div class="flex justify-center gap-4 sm:h-[12svh] sm:items-center">
                @if (model.buttons === DialogModalButtons.Delete) {
                    <bizz-alert type="error" message="{{ model.message | translate }}"></bizz-alert>
                } @else {
                    <p class="text-center text-base font-normal">
                        {{ model.message | translate }}
                    </p>
                }
            </div>
        }
        @if (model.mode === DialogModalModelMode.confirmation) {
             <div class="mt-6 flex w-full items-center gap-4 rounded bg-yellow-500/20 p-4 text-button">
                <bizz-icon iconName="circle-exclamation" class="size-8 text-yellow-500"></bizz-icon>
                <span class="text-sm text-light">You are currently offline. Logging out now will prevent you from logging back in until an internet connection has been reestablished. </span>
            </div>
            <div class="flex items-center flex-col w-full text-start min-h-24 [&>label]:self-start gap-2">
                 <label class="m-auto text-sm text-default">
                    Please confirm this action by typing the word
                    "<b>{{ model.confirmationtext }}</b>"
                    {{ 'Below' | translate }}
                    <span class="ml-0.5 text-red-400">*</span>
                </label>
                <input class="w-1/3" type="text" [(ngModel)]="enteredConfirmText" name="password" placeholder="{{model.confirmationtext}}"
                                  autofocus/>
            </div>
        }
    </div>
    <div class="modal-buttons">
        @if (model.showCancelButton) {
            <button class="default" (click)="dialogRef.close(DialogModalButtons.Cancel)">
                {{ 'Cancel' | translate }}
            </button>
        }
        @switch (model.buttons) {
            @case (DialogModalButtons.Ok) {
                <button class="save min-w-16" (click)="dialogRef.close(DialogModalButtons.Ok)"
                        [disabled]="(model.mode === DialogModalModelMode.confirmation && enteredConfirmText != model.confirmationtext)">
                    {{ 'Ok' | translate }}
                </button>
            }
            @case (DialogModalButtons.Confirm) {
                <button class="save" (click)="dialogRef.close(DialogModalButtons.Confirm)"
                        [disabled]="(model.mode === DialogModalModelMode.confirmation && enteredConfirmText != model.confirmationtext)">
                    {{ 'Confirm' | translate }}
                </button>
            }
            @case (DialogModalButtons.Delete) {
                <button class="delete" (click)="dialogRef.close(DialogModalButtons.Delete)"
                        [disabled]="(model.mode === DialogModalModelMode.confirmation && enteredConfirmText != model.confirmationtext)">
                    {{ 'Delete' | translate }}
                </button>
            }
        }
    </div>
</div>
